<h1>{{data.title}}</h1>
<div class="form-inputs">
  <h4>{{data.content}}</h4>
</div>
<div class="flex-container">
  <button mat-raised-button
          id="topbar-save-dialog-save_button"
          class="mat-raised-button btn-green flex-box"
          type="button"
          (click)="save()"
  >{{data.save}}
  </button>
  <button mat-raised-button
          id="topbar-save-dialog-cancel_button"
          class="mat-raised-button btn-cancel flex-box"
          type="button"
          (click)="cancel()"
  >{{data.noSave}}
  </button>
</div>